import ProductCard from "./ProductCard";
import ShopContext from "^/ShopContext";
import { useContext, useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import { Link } from "react-router-dom";
const CategoryProductGrid = (props) => {

  const {
    list,
    categoryId = 746,
    heading='Ready to Build Police Vehicles'
  } = props;
  const {
    catProdLoading,
    getSecondaryProducts
  } = useContext(ShopContext);

  if (list?.map?.length) {
    document.querySelector('#init-product-grid')?.remove();
  }
  useEffect(() => {
    getSecondaryProducts(categoryId, 'Ready to Build Police Vehicles');
  }, [])

  return (
    <div className='flex product-page' >
      <aside className='filter-container'></aside>
      <div className='product-grid-container flex column' style={{marginTop: 24}}>
        <a href={`/categories/${categoryId}`}>
        <h2>{heading}</h2>
        </a>
        <div className='grid product-grid'>
          {
            catProdLoading ?
              <Spinner />
              :
              list?.map(each =>
                <ProductCard
                  {...each}
                  key={each.id}

                />

              )
          }
        </div>
      </div>
    </div>
  )
}
export default CategoryProductGrid;